<template>
  <div class="users content-container flex-column">
    <div class="content-wrap">
      <!-- Górny panel z menu i tłem po lewej -->
      <div class="d-flex users-section-container no-content">
        <div class="users-section"></div>
        <div class="content-wrap">
          <TopMenu />
        </div>
      </div>

      <!-- Widok dodawania nowego użytkownika -->
      <div v-if="showAddUser" @cancel="showAddUser = false" class="d-flex users-section-container">
        <div class="users-section">
          <span>
            {{ t('add-user') }}
          </span>
        </div>
        <div class="content-wrap">
          <div class="collapse show" id="addUser">
            <!-- Komponent do dodawania użytkownika.
                 Nasłuchuje eventów: zamknięcie widoku lub dodanie użytkownika -->
            <AddUser @user-added="handleUserAdded" @cancel-add-user="showAddUser = false" />
          </div>
        </div>
      </div>

      <!-- Widok listy użytkowników (główna lista, jeśli nie dodajemy) -->
      <div v-else class="d-flex users-section-container">
        <div class="users-section">
          <span>
            {{ t('user-list') }}
          </span>
        </div>
        <div class="content-wrap">
          <!-- Pasek nagłówka listy użytkowników + wyszukiwarka + przycisk dodawania -->
          <div v-if="!isEditMode" class="d-flex align-items-center justify-content-between user-list-header">
            <h3>{{ t('user-list').toUpperCase() }}</h3>
            <div class="search-bar">
              <!-- Przycisk + do wyświetlenia formularza dodawania użytkownika -->
              <span @click="toggleAddUser" class="add-user-action">+</span>
              <!-- Wyszukiwarka po użytkownikach -->
              <input
                type="text"
                v-model="searchQuery"
                :placeholder="t('search-user')"
              />
            </div>
          </div>
          <!-- Lista użytkowników (przekazuje searchQuery do filtrowania) -->
          <div class="collapse show" id="userList">
            <UserList 
              :search-query="searchQuery" 
              @clearSearch="searchQuery = ''"
              @editMode="isEditMode = $event"
              :key="userListKey"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopMenu from "../components/TopMenu.vue";
import UserList from "@/components/UserList";
import AddUser from "@/components/AddUser";
import Users from "@/services/Users";
import moment from "moment";

export default {
  name: "HomeView",
  components: {
    UserList,
    AddUser,
    TopMenu,
  },
  data() {
    return {
      isDownloading: false, // status pobierania pliku
      searchQuery: '',      // fraza wyszukiwania użytkownika
      userListKey: 0,       // klucz do wymuszenia reloadu listy użytkowników
      showAddUser: false,   // czy widok dodawania użytkownika jest widoczny
      isEditMode: false,    // czy edytujemy konkretnego użytkownika (UserList ustawia ten tryb)
    };
  },
  methods: {
    // Przełącza formularz dodawania użytkownika
    toggleAddUser() {
      this.showAddUser = !this.showAddUser;
    },
    // Pobranie logów użytkowników do ZIP-a (ostatnie 7 dni)
    retrieveZip() {
      this.isDownloading = true;
      const dateFrom = moment().subtract(7, "days").toISOString(false);
      const dateTo = moment().toISOString(false);
      Users.getZip(dateFrom, dateTo)
        .then((data) => {
          Users.fetch(data.link)
            .then((response) => {
              const link = document.createElement("a");
              link.href = URL.createObjectURL(response);
              link.download = "user_logs";
              link.click();
              this.isDownloading = false;
              URL.revokeObjectURL(link.href);
            })
            .catch(console.error);
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
    },
    // Po dodaniu użytkownika ukrywa formularz i odświeża listę użytkowników
    handleUserAdded() {
      this.showAddUser = false;
      this.userListKey++;
    }
  },
};
</script>

<style scoped>
.users-section-container {
  width: 100%;
}

.user-list-header {
  padding-top: .5rem;
  background-color: white;
  border-bottom: 1px solid #ccc;
}

.search-bar input {
  margin-right: 1rem;
  margin-bottom: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.users-section {
  width: 365px;
  background: url("../assets/l-filter-bg.png") repeat-y right;
}

.users-section > span {
  padding: 10px 25px;
  position: relative;
  display: block;
}

.icon-collapse {
  background: url("../assets/icons/zwin.png") no-repeat left top;
  width: 19px;
  height: 19px;
  position: absolute;
  cursor: pointer;
  right: 10px;
}

.collapsed.icon-collapse {
  background: url("../assets/icons/rozwin.png") no-repeat left top;
}

.content-wrap h3 {
  padding: 15px 25px;
  background-color: white;
}

.add-user-action {
  position: relative;
  top: 3px;
  cursor: pointer;
  font-size: 28px;
  margin-right: 1rem;
}
</style>
